<template>
  <div class="albums-page">
    <AlbumTemplatesList />
  </div>
</template>

<script>
import AlbumTemplatesList from './AlbumTemplatesList.vue';

export default {
  name: 'AlbumsPage',
  components: {
    AlbumTemplatesList,
  },
};
</script>

<style lang="scss" scoped>
.albums-page {
  padding: 20px;
}
</style>
